import { ErrorLogComponent } from '@cian/error-log-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { CardSectionNew } from 'shared/components/CardSectionNew';
import { SimilarNewObjectsContainer } from 'shared/components/similar_newobjects/container';
import { BargainTermsContainer } from 'shared/containers/BargainTermsContainer';
import { RealtorRequestTrapContainer } from 'shared/containers/valuationTraps';

import { FeedbackComplaintPopupContainer } from '../../FeedbackExperiment/components/PopupWithComplaint/ComplaintPopup/container';
import { FeedbackPopupContainer as FeedBackPopupC } from '../../FeedbackExperiment/components/PopupWithComplaint/FeedbackPopup';
import { PopupFeedbackSentContainer } from '../../FeedbackExperiment/components/PopupWithForm/PopupFeedbackSent';
import { KpInfoContainer } from '../../components/KpInfo';
import { LabelsLayoutNew } from '../../components/LabelsLayout';
import {
  OfferCardPageLayout,
  OfferCardPageLayoutCenter,
  OfferCardPageLayoutFooter,
  OfferCardPageLayoutTop,
  OfferCardPageLayoutAside,
} from '../../components/OfferCardPageLayout';
import { OfferHistoryContainer } from '../../components/OfferHistory/containers';
import { ReadyBusinessAssignment } from '../../components/ReadyBusinessAssignment';
import { SafeRentDescriptionContainer } from '../../components/SafeRentDescription';
import { AdminButtonsContainer } from '../../components/admin_buttons/container';
import { CommercialAboutBuildingContainer } from '../../components/commercial/about_building/container';
import { HeaderAdminPanelContainer } from '../../components/header_admin_panel/container';
import { OfferBreadcrumbsContainer } from '../../components/offer_breadcrumbs/container';
import { canShowTrap } from '../../components/offer_card_page/helpers';
import { OfferGallery } from '../../components/offer_gallery';
import { OfferIsHiddenBlock } from '../../components/offer_hidden_block';
import { OfferRefusedContainer } from '../../components/offer_refused/container';
import { OfferUnpublishedContainer } from '../../components/offer_unpublished/container';
import { HideOfferTopPopup } from '../../components/popups/hide_offer_top_popup';
import { LegendModalContainer } from '../../components/popups/legend/container';
import { PrintModalContainer } from '../../components/popups/print/container';
import { RemoveModalContainer } from '../../components/popups/remove/container';
import { PrintInformationContainer } from '../../components/print_information/container';
import { PrintPhotoContainer } from '../../components/print_photo/container';
import { SUBURBAN } from '../../constants/suburban';
import { abUseExperimentsSelector, isNewbuildingSelector } from '../../selectors';
import { selectBuyAnalyticsReportAvailability } from '../../selectors/buyAnalyticsModal';
import { isDealRent as isDealRentSelector } from '../../selectors/isDealRent';
import { isVillagePromotionsShown as isVillagePromotionsShownSelector } from '../../selectors/isVillagePromotionsShown';
import { getOffer } from '../../selectors/newObject';
import { isNewbuildingFromDeveloperSelector } from '../../selectors/offerData/offer/isNewbuildingFromDeveloperSelector';
import { IState } from '../../store';
import { IApplicationContext } from '../../types/applicationContext';
import { isCountrysideCardIntegrated as isCountrysideCardIntegratedSelector } from '../../utils/countrysideCardIntegration';
import { isLocationSubscriptionExperimentEnabled } from '../../utils/suburbanLocationSubscriptionExperiment';
import { TgbBottomBannersContainer } from '../Adfox/TgbBottomBannersContainer';
import { AnalyticsBlockContainer } from '../AnalyticsBlockNew';
import { ApplicationContext } from '../ApplicationContext';
import { AsideRedesignedContainer } from '../AsideRedesigned/AsideRedesigned';
import { BottomAuthorBlockContainer } from '../BottomAuthorBlockNew';
import { CallbackWidgetContainer } from '../CallbackWidgetContainer';
import { ChatContainer } from '../ChatContainer';
import { ChatPopupContainer } from '../ChatPopupContainer';
import { CianLayoutContainer } from '../CianLayout';
import { ComparisonNotificationLoadableContainer } from '../ComparisonNotificationContainer';
import { CountryBuildingsBannersContainer } from '../CountryBuildingsBannersContainer';
import { DealSaleLabelNewContainer } from '../DealSaleLabelContainer';
import { DescriptionContainer } from '../Description/Description';
import { FavoritesFoldersContainer } from '../FavoritesFoldersContainer';
import { FlatViewOrderTooltipContainer } from '../FlatViewOrderTooltip';
import { HeatIndexContainer } from '../HeatIndexContainer';
import { IdenticalOffersContainer } from '../IdenticalOffersContainer';
import { LocationSubscriptionContainer } from '../LocationSubscriptionContainer';
import { MainNewContainer } from '../MainContainer';
import { MortgageCalculatorContainer } from '../MortgageCalculator';
import { NavigationContainerNew } from '../NavigationNew';
import NewbuildingAdvantages from '../NewbuildingAdvantages/NewbuildingAdvantages';
import { NewbuildingBookedFromDeveloperModalContainer } from '../NewbuildingBookedFromDeveloperModalContainer';
import { NewbuildingBookingModalContainer } from '../NewbuildingBookingModalContainer';
import { NewbuildingDecorationsContainer } from '../NewbuildingDecorations/NewbuildingDecorations';
import { NewbuildingMortgageSectionLoadable } from '../NewbuildingMortgageSection';
import { NewbuildingPromosSectionContainer } from '../NewbuildingPromosSection';
import { NewbuildingStatsContainer } from '../NewbuildingStats/NewbuildingStats';
import { NewbuildingTiledCarouselContainerLoadable } from '../NewbuildingTiledCarousel';
import { NewbuildingsFromDeveloperLazy } from '../NewbuildingsFromDeveloper';
import { ObjectFactoidsContainer } from '../ObjectFactoid/ObjectFactoid';
import { ObjectSummaryTitleContainer } from '../ObjectSummaryTitle/ObjectSummaryTitleContainer';
import { OfferMapContainer } from '../OfferMapContainer';
import { OfferMetaDataContainer } from '../OfferMetaData/OfferMetaData';
import { OfferSummaryInfoNew } from '../OfferSummaryInfoNew';
import { OfferValuationContainer } from '../OfferValuation';
import { GoodPriceLabelNewContainer } from '../OfferValuation/containers/GoodPriceLabel';
import { OnlyCianLabelNewContainer } from '../OnlyCianLabelContainer';
import { PhoneWarningModalContainer } from '../PhoneWarningModalContainer';
import { PossibleAssignmentContainer } from '../PossibleAssignment';
import { RecommendedVillagesContainer } from '../RecommendedVillagesContainer';
import { RosreestrFlatSaleContainerNew } from '../RosreestrFlatSaleContainer';
import { RosreestrInfoContainerNew } from '../RosreestrInfoContainerNew';
import { SeoLinksContainer } from '../SeoLinks/SeoLinksContainer';
import { SimilarOffersGroupsContainer } from '../SimilarOffersRedesigned';
import { SuburbanBannerContainer } from '../SuburbanBannerContainer';
import { VillagePromotionsContainer } from '../VillagePromotionsContainer';
import { WarningsContainer } from '../WarningsContainer';
// TODO: Для перезаписи фона страницы, удалить файл при раскатке эксперимента
import './styles.css';

interface IOfferCardPageNewContainerProps {
  context: IApplicationContext;
}

const OfferCardPageNewContainer = ({ context }: IOfferCardPageNewContainerProps) => {
  const hiddenObjectsLkUrl = context.config.get<string>('hiddenObjects.lkUrl') || '';

  const offer = useSelector(getOffer);
  const isPublished = offer.status === 'published';
  const isNewBuilding = useSelector(isNewbuildingSelector);
  const isNewbuildingFromDeveloper = useSelector(isNewbuildingFromDeveloperSelector);
  const isCountrysideCardIntegrated = useSelector(isCountrysideCardIntegratedSelector);
  const isDealRent = useSelector(isDealRentSelector);
  const showTrap = canShowTrap(offer);
  const isVillagePromotionsShown = useSelector(isVillagePromotionsShownSelector);
  const isSuburban = SUBURBAN.includes(offer.category);
  const abUseExperiments = useSelector(abUseExperimentsSelector);
  const isLocationSubscription = isLocationSubscriptionExperimentEnabled(abUseExperiments);

  const isHiddenByUser = useSelector((state: IState) => state.offerData.isHiddenByUser);
  const isTopPopupOpened = useSelector((state: IState) => state.hideOffer.isTopPopupOpened);
  const hideOfferStatus = useSelector((state: IState) => state.hideOffer.status);
  const hideOfferErrorMessage = useSelector((state: IState) => state.hideOffer.errorMessage);
  const isBuyAnalyticsButtonEnabled = useSelector(selectBuyAnalyticsReportAvailability);

  return (
    <ApplicationContext.Provider value={context}>
      <OfferCardPageLayout>
        <FeedBackPopupC />
        <FeedbackComplaintPopupContainer />

        <PopupFeedbackSentContainer />
        <FlatViewOrderTooltipContainer />
        <OfferCardPageLayoutTop>
          <OfferBreadcrumbsContainer />
          <OfferMetaDataContainer />
          <HeaderAdminPanelContainer />
          <OfferRefusedContainer config={context.config} />
          <OfferUnpublishedContainer />
          <AdminButtonsContainer />
          <ErrorLogComponent logger={context.logger}>
            <WarningsContainer />
          </ErrorLogComponent>
          {!isPublished && <SimilarOffersGroupsContainer />}
        </OfferCardPageLayoutTop>

        {isTopPopupOpened && (
          <HideOfferTopPopup
            status={hideOfferStatus}
            hidden={Boolean(isHiddenByUser)}
            lkUrl={hiddenObjectsLkUrl}
            hideOfferErrorMessage={hideOfferErrorMessage}
          />
        )}

        {isHiddenByUser && <OfferIsHiddenBlock lkUrl={hiddenObjectsLkUrl} />}

        <OfferCardPageLayoutCenter>
          <ErrorLogComponent logger={context.logger}>
            <LabelsLayoutNew>
              <GoodPriceLabelNewContainer />
              <OnlyCianLabelNewContainer />
              <DealSaleLabelNewContainer />
            </LabelsLayoutNew>
            <MainNewContainer />
          </ErrorLogComponent>
          {isPublished && (
            <div>
              {isNewbuildingFromDeveloper && <NewbuildingTiledCarouselContainerLoadable openTourInPopUp={true} />}
              {!isNewbuildingFromDeveloper && <OfferGallery reactErrorLogger={context.logger} />}
              <PrintPhotoContainer />
            </div>
          )}

          {isDealRent && <SafeRentDescriptionContainer />}
          <ObjectSummaryTitleContainer />
          <ObjectFactoidsContainer />

          {isBuyAnalyticsButtonEnabled && <AnalyticsBlockContainer />}

          <DescriptionContainer />

          <PossibleAssignmentContainer />
          <ReadyBusinessAssignment />

          <BargainTermsContainer />
          <CommercialAboutBuildingContainer />

          <OfferSummaryInfoNew />

          <RosreestrFlatSaleContainerNew />
          <RosreestrInfoContainerNew />

          {!isNewBuilding && <CianLayoutContainer />}
          {isNewbuildingFromDeveloper && <NewbuildingDecorationsContainer />}
          {isNewbuildingFromDeveloper && <NewbuildingPromosSectionContainer isRedesign={true} />}
          {isVillagePromotionsShown && <VillagePromotionsContainer />}
          {isPublished && [
            <div key="published-data">
              {isNewbuildingFromDeveloper && <NewbuildingAdvantages />}
              {isCountrysideCardIntegrated && <KpInfoContainer />}

              <ErrorLogComponent logger={context.logger}>
                <OfferMapContainer />
              </ErrorLogComponent>

              {!isNewBuilding && !isDealRent && showTrap && (
                <CardSectionNew withBorders>
                  <RealtorRequestTrapContainer withoutBorders={true} />
                </CardSectionNew>
              )}

              {isSuburban && isLocationSubscription && <LocationSubscriptionContainer />}

              <ErrorLogComponent logger={context.logger}>
                <RecommendedVillagesContainer />
              </ErrorLogComponent>

              {isNewbuildingFromDeveloper && (
                <NewbuildingMortgageSectionLoadable header="Ипотечные предложения" showHeader={true} />
              )}
              {!isNewbuildingFromDeveloper && <MortgageCalculatorContainer />}
              {isNewbuildingFromDeveloper && <NewbuildingStatsContainer />}

              <HeatIndexContainer />

              <CardSectionNew>
                <OfferValuationContainer />
              </CardSectionNew>

              <ErrorLogComponent logger={context.logger}>
                <CountryBuildingsBannersContainer />
              </ErrorLogComponent>

              <OfferHistoryContainer />
              <ErrorLogComponent logger={context.logger}>
                <CardSectionNew>
                  <BottomAuthorBlockContainer />
                </CardSectionNew>
              </ErrorLogComponent>
              {isSuburban && <SuburbanBannerContainer />}
            </div>,
          ]}
        </OfferCardPageLayoutCenter>

        <OfferCardPageLayoutAside>
          <AsideRedesignedContainer />
        </OfferCardPageLayoutAside>
      </OfferCardPageLayout>
      <OfferCardPageLayoutFooter>
        <NewbuildingsFromDeveloperLazy />
        <IdenticalOffersContainer />
        {isPublished && <SimilarOffersGroupsContainer />}
        <SeoLinksContainer />
        <SimilarNewObjectsContainer />
        <TgbBottomBannersContainer />
      </OfferCardPageLayoutFooter>

      <CallbackWidgetContainer />

      <PrintModalContainer />
      <PrintInformationContainer />

      <LegendModalContainer />
      <RemoveModalContainer />
      <NavigationContainerNew />

      <ChatContainer config={context.config} />
      <ChatPopupContainer />
      <FavoritesFoldersContainer />
      <NewbuildingBookingModalContainer />
      <NewbuildingBookedFromDeveloperModalContainer />
      <PhoneWarningModalContainer />
      <ComparisonNotificationLoadableContainer />
    </ApplicationContext.Provider>
  );
};

// eslint-disable-next-line import/no-default-export
export default OfferCardPageNewContainer;
